import React from "react";
import { connect } from "react-redux";
import InspectionDetailsApi from "../../transactions/inspection/InspectionDetailsApi";
import { GridLayout } from "../../../../common/GridLayout";
import { LoadPanel } from 'devextreme-react/load-panel';
import InspectionAttribute from './InspectionAttribute'
import ScrollView from "devextreme-react/scroll-view";
import Popup from "devextreme-react/popup";
import DataSource from "devextreme/data/data_source";
import ArrayStore from 'devextreme/data/array_store';
import Button from "devextreme-react/button";
import { SelectBox } from 'devextreme-react/select-box';
import { createStore } from 'devextreme-aspnet-data-nojquery';
import routes from "../../../../assets/apiRoutes.json"
import DataGrid, {
    Column,
    Paging,
    FilterRow,
    FilterPanel,
    ColumnChooser,
    ColumnChooserSearch,
    FilterBuilderPopup,
    StateStoring,
    Export,
    Pager,
    HeaderFilter,
    Selection,
    Toolbar,
    Item,
    Sorting,
    Editing,
    ColumnFixing
} from 'devextreme-react/data-grid';

const filterBuilderPopupPosition = {
    of: window,
    at: "top",
    my: "top",
    offset: { y: 10 },
};
let accessToken = '';
const gridKey = "6c7cff3e-002e-46e9-85c7-0250dad062fc";
const loadState = () => { return GridLayout.sendStorageRequest(gridKey, "GET", accessToken); }
const saveState = (state) => { 
    
    for (let i = 0; state.columns != null && i < state.columns.length; i++) 
    {
        if (state.columns[i].dataField.startsWith("attrcol")) 
        {
            state.columns.splice(i, 1);
            i--;
        }
    }
    
    GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state); 
}
let inspectionTypeSelectBox = React.createRef();
const dataGrid = React.createRef();
class InspectionHistory extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isQuestionFormButtonDisable: true,
            isQuestionFormPopupVisibile: false,
            loadIndicatorVisible: false,
            selectedrowids: [],
            inspectiontype: "",
            attributeColumns: []
        };

        accessToken = props.oidc.user.access_token;
        this.InspectionDetailsApi = new InspectionDetailsApi(props.oidc.user.access_token);
        this.OpenQuestionForm = this.OpenQuestionForm.bind(this);
        this.handleClosePopUpCallback = this.handleClosePopUpCallback.bind(this);
        this.onSelectionChanged = this.onSelectionChanged.bind(this);
        this.InspectionTypeChanged = this.InspectionTypeChanged.bind(this);
        this.LoadInspectionTypes = this.LoadInspectionTypes.bind(this);
        this.onContentReady = this.onContentReady.bind(this);
        this.rowUpdating = this.rowUpdating.bind(this);
        this.editorPreparing = this.editorPreparing.bind(this);

        var that = this;
        this.dataSource = createStore({
            key: 'inspectiondetailrowid',
            loadParams:
            {
                inspectiontype: function ()
                {
                    return that.state.inspectiontype;
                }
            },
            loadUrl: `${window._env_.REACT_APP_APIS}/${routes.Inspection.LoadAllDetailInspectionHistory}`,
            updateUrl: `${window._env_.REACT_APP_APIS}/${routes.Inspection.UpdateInspectionData}`,
            onBeforeSend: function(method, ajaxOptions) {
              ajaxOptions.headers = {
                Authorization: `Bearer ${accessToken}`
              };
            }
          });
    }
    InspectionTypeChanged = async (inspectiontypeVal) => {
        try {
            this.setState({ 
                inspectiontype: inspectiontypeVal,
                loadIndicatorVisible: true
             });
            if(inspectiontypeVal != null && inspectiontypeVal != "")
            {
                var api = this.InspectionDetailsApi.loadInspectionGridColumns(inspectiontypeVal);
            
                const [inspectionGridColumns] = await Promise.all([api]);
                if (inspectionGridColumns.data) {
                    for (var i=0 ;i < this.state.attributeColumns.length;i++)
                    {
                        dataGrid.current.instance().deleteColumn(this.state.attributeColumns[i].dataField);
                    }
            
                    for(var i=0; i < inspectionGridColumns.data.columns.length; i++)
                    {
                        inspectionGridColumns.data.columns[i].allowFiltering = false;
                        dataGrid.current.instance().addColumn(inspectionGridColumns.data.columns[i]);
                    }
    
                    this.setState({
                        attributeColumns: inspectionGridColumns.data.columns
                    });
    
                    dataGrid.current.instance().refresh();
                }
            }
        }
        catch (error) {
            console.error("Error loading inspection grid columns:", error);
        }
        finally {
            this.setState({ loadIndicatorVisible: false });
        }
    }

    LoadInspectionTypes = async () => {
        try {
            this.setState({ loadIndicatorVisible: true });
            var api = this.InspectionDetailsApi.loadInspectionTypes();
            const [inspectionTypeDataSource] = await Promise.all([api]);
            if (inspectionTypeDataSource.data.success) {
                this.setState({
                    loadIndicatorVisible: false
                });
                
                let InspectionTypeDataStore = new DataSource({
                    store: new ArrayStore({
                        data: inspectionTypeDataSource.data.resultdata
                    }),
                    paginate: true,
                    pageSize: 100
                });

                inspectionTypeSelectBox.current.instance().option(
                    "dataSource",
                    InspectionTypeDataStore
                );

                
            }
            else
            {

                this.setState({
                    loadIndicatorVisible: false
                }); 
            }
        } catch (e) {
            console.log(e, "Error in loading inspection type codes.");
            this.setState({ loadIndicatorVisible: false });
        }
    }
    onSelectionChanged({ selectedRowKeys, selectedRowsData, currentSelectedRowKeys, currentDeselectedRowKeys }) {
        const uniq = [...new Set(selectedRowsData.map((itm) => itm.inspectionid.trim()))];
        this.setState({
            isQuestionFormButtonDisable: !(uniq.length == 1),
            selectedrowids: selectedRowKeys
        });
    }
    componentDidMount() {
        this.LoadInspectionTypes();
    }
    
    OpenQuestionForm(e) {
        this.setState({ isQuestionFormPopupVisibile: true });
    }

    handleClosePopUpCallback() {
        this.setState({
            isQuestionFormPopupVisibile: false,
        });
        dataGrid.current.instance().refresh();
    };

    onContentReady(e) {
        if (!e.component._hasLoaded) {
            e.component._hasLoaded = true;
            e.component.option("dataSource", this.dataSource);
        }
    }

    rowUpdating(e) {
        if (!e.newData.hasOwnProperty('inspectiontype')) 
        {
            e.newData['inspectiontype'] = e.oldData['inspectiontype'];
        }
    }

    editorPreparing(e) {
        if (e.parentType === "dataRow" && e.hasOwnProperty('dataField') && e.hasOwnProperty('editorName') && e.dataField.startsWith("attrcoltextarea")) 
        {
            e.editorName = "dxTextArea"; 
            e.editorOptions.autoResizeEnabled = true;
        }
    }

    render() {
        return (
            <div className="h-100 m-0" style={{ height: '100%', overflowY: 'hidden', display: 'flex', flexDirection: 'column', position: 'relative' }}>
                <LoadPanel
                    shadingColor="rgba(0,0,0,0.4)"
                    visible={this.state.loadIndicatorVisible}
                    showIndicator={true}
                    shading={true}
                    showPane={true}
                    hideOnOutsideClick={false}
                />
                <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
                    ref={dataGrid}
                    onContentReady={this.onContentReady}
                    onRowUpdating={this.rowUpdating}
                    showBorders={true}
                    className="ReportFilterPanelHeightAccordionClose"
                    style={{ flex: '1 1 auto', minHeight: 0 }}
                    allowColumnResizing={true}
                    allowColumnReordering={true}
                    rowAlternationEnabled={true}
                    columnAutoWidth={true}
                    onSelectionChanged={(e) => this.onSelectionChanged(e)}
                    onEditorPreparing={this.editorPreparing}
                    showRowLines={true}
                    showColumnLines={false}
                    remoteOperations={true}>
                        <ColumnChooser
                            enabled={true}
                            title="Choose Column"
                            width={290}
                            height={900}
                            sortOrder="asc"
                        >
                            <ColumnChooserSearch
                                enabled={true}
                                editorOptions={{ placeholder: 'Search column' }} />
                        </ColumnChooser>
                        <ColumnFixing enabled={true}/>,
                        <LoadPanel enabled={true} />
                        <FilterRow visible={true} />
                        <FilterPanel visible={true} />
                        <HeaderFilter visible={true} />
                        <FilterBuilderPopup position={filterBuilderPopupPosition} />
                        <Export enabled={true} allowExportSelectedData={true} text="Export" />
                        <Selection mode="multiple" />
                        <Paging defaultPageSize={10} />
                        <Pager
                            visible={true}
                            showPageSizeSelector={true}
                            allowedPageSizes={[10, 20, 50, 500, 1000, "all"]}
                            showNavigationButtons={true}
                        />
                        <Sorting mode="multiple" />
                        <StateStoring
                            enabled={true}
                            type="custom"
                            customLoad={loadState}
                            storageKey={gridKey}
                            customSave={saveState}
                        />
                        <Editing
                            mode="cell"
                            refreshMode="repaint"
                            allowUpdating={true}
                            allowAdding={false}
                            allowDeleting={false} />
                        <Column dataField="inspectionid" caption="Inspection ID" allowEditing={false} cssClass="column-readonly"></Column>
                        <Column dataField="rametcode" caption="Ramet Code" allowEditing={false} cssClass="column-readonly"></Column>
                        <Column dataField="supervisor" caption="Supervisor" allowEditing={false} cssClass="column-readonly"></Column>
                        <Column dataField="inspectiondate" dataType="date" caption="Inspection Date" allowEditing={false} cssClass="column-readonly"></Column>
                        <Column dataField="inspectiontypecode" caption="Inspection Type" allowEditing={false} cssClass="column-readonly" allowFiltering={false} ></Column>    
                        <Column dataField="posy" caption="Row" allowEditing={false} cssClass="column-readonly"></Column>
                        <Column dataField="posx" caption="Col" allowEditing={false} cssClass="column-readonly"></Column>
                        <Column dataField="orchardcode" caption="Orchard" allowEditing={false} cssClass="column-readonly"></Column>
                        <Column dataField="blockcode" caption="Block" allowEditing={false} cssClass="column-readonly"></Column>
                        <Column dataField="locationcode" caption="Location" allowEditing={false} cssClass="column-readonly"></Column>
                        <Column dataField="description" caption="Ramet Description" visible={false} allowEditing={false} cssClass="column-readonly"></Column>
                        <Column dataField="orchardtype" caption="Orchard Type" visible={false} allowEditing={false} cssClass="column-readonly"></Column>
                        <Column dataField="elevation" caption="Elevation" visible={false} allowEditing={false} cssClass="column-readonly"></Column>
                        <Column dataField="species" caption="Species" visible={false} allowEditing={false} cssClass="column-readonly"></Column>
                        <Column dataField="blockcycle" caption="Block Cycle" visible={false} allowEditing={false} cssClass="column-readonly"></Column>
                        <Column dataField="stimcycle" caption="Stim Cycle" visible={false} allowEditing={false} cssClass="column-readonly"></Column>
                        <Column dataField="stimstatus" caption="Stim Status" visible={false} allowEditing={false} cssClass="column-readonly"></Column>
                        <Column dataField="breedingarea" caption="Breeding Area" visible={false} allowEditing={false} cssClass="column-readonly"></Column>
                        <Column dataField="rootstock" caption="Root Stock" allowEditing={false} cssClass="column-readonly"></Column>
                        <Column dataField="graftdate" dataType="date" caption="Graft Date" allowEditing={false} cssClass="column-readonly"></Column>
                        <Column dataField="plantdate" dataType="date" caption="Plant Date" allowEditing={false} cssClass="column-readonly"></Column>
                        <Column dataField="parent"  caption="Parent" allowEditing={false} cssClass="column-readonly"></Column>
                        <Toolbar>
                            <Item location="before">
                                <SelectBox
                                    ref={inspectionTypeSelectBox}
                                    searchEnabled={true}
                                    placeholder="Inspection Type"
                                    onValueChanged={(data) => this.InspectionTypeChanged(data.value)}
                                    displayExpr="name"
                                    valueExpr="id"
                                    name="inspection-type"
                                    className="w-100"
                                    value={this.state.inspectiontype} />
                            </Item>
                            <Item location="center">
                                <Button onClick={(e) => this.OpenQuestionForm(e)}
                                    disabled={this.state.isQuestionFormButtonDisable}
                                    text="Question Form"
                                    type="default"
                                    stylingMode="contained"
                                    className="margin-right" />
                            </Item>
                            <Item name="exportButton" />
                            <Item name="columnChooserButton" />
                        </Toolbar>
                    </DataGrid>
                {
                    this.state.isQuestionFormPopupVisibile && <Popup
                        visible={this.state.isQuestionFormPopupVisibile}
                        onHiding={(e) => this.handleClosePopUpCallback(e)}
                        dragEnabled={false}
                        hideOnOutsideClick={true}
                        showCloseButton={true}
                        showTitle={true}
                        title="Inspection Questions"
                        container="#root"
                        closeOnOutsideClick={true}
                        height={500}
                        width={900}>
                        <ScrollView width="100%" height="100%">
                            <InspectionAttribute inspectiontype={this.state.inspectiontype}
                                inspectionDetailRowids={this.state.selectedrowids}
                                parentCallback={this.handleClosePopUpCallback}
                            ></InspectionAttribute>
                        </ScrollView>
                    </Popup>
                }
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(InspectionHistory);